import { Button, Divider, Input, Modal, Select, Space, Spin, Typography } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { InboxOutlined, PlusOutlined, UserAddOutlined, UserOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";
import { getParametre, saveDecaissement } from "../../../../hooks/useHooks";
import TextArea from "antd/es/input/TextArea";
import { PARAMETERS } from "../../../../variables/constants";
import AmountInputNumber from "../../../../components/inputs/AmountInputNumber";

const { Option } = Select;
const { Title } = Typography;

const ReglementRecoursModal = ({ sinistre, modalControl }) => {
    let victimes = sinistre.victimes || [];
    const experts = sinistre.experts || [];
    const evaluations = sinistre.evaluations || [];
    const [beneficiairesVictimes, setBeneficiairesVictimes] = useState([]);
    const [beneficiairesExperts, setBeneficiairesExperts] = useState([])
    const [sousEvaluationsSelected, setSousEvaluationsSelected] = useState([])
    const [montantReglement, setMontantReglement] = useState(0)
    const [beneficiaire, setBeneficiaire] = useState(null)
    const [isVictimeBeneficiaire, setIsVictimeBeneficiaire] = useState(null)
    const [completeSousEvSelected, setCompleteSousEvSelected] = useState([])
    const [honoraire, setHonoraire] = useState(0)
    const [decaissementLoading, setDecaissementLoading] = useState(false);
    const [options, setOptions] = useState([]);
    const [motifsLoading, setMotifsLoading] = useState(false);
    const [motifs, setMotifs] = useState([]);
    const [name, setName] = useState('');
    const [motifReglement, setMotifReglement] = useState();
    const [textValue, setTextValue] = useState('');

    const inputRef = useRef(null);


    const handleRetrieveBeneficiaire = (value) => {
        if (isVictimeBeneficiaire && value.length > 0) {
            setBeneficiaire(victimes?.filter((v) => v.codeId === value)[0])
        }
        if (isVictimeBeneficiaire === false && value.length > 0) {
            setBeneficiaire(experts?.filter((v) => v.codeId === value)[0])
        }
    }

    const handleBeneficiaireChange = (value) => {
        setBeneficiairesVictimes(value);
        handleRetrieveBeneficiaire(value);
    };
    const handleExpertChange = (value) => {
        console.log("value: ", value);
        let check = victimes?.find((v) => v.codeId === value);
        if (check) {
            setBeneficiaire(check);
            setBeneficiairesVictimes(value);
        } else {
            setBeneficiaire(experts?.find((v) => v.codeId === value));
            setBeneficiairesExperts(value);
        }
    };

    const handleSousEvChange = (value) => {
        setSousEvaluationsSelected(value);
        const tempSous = sousEvaluations?.filter((v) => sousEvaluationsSelected?.includes(v.codeId))
        setCompleteSousEvSelected(tempSous)
    };

    const hendleBeneficiaireIsVictimeChoice = (value) => {
        setIsVictimeBeneficiaire(value)
    }
    victimes = victimes.filter((victime) => victime.personne)
    const evaluation = evaluations.filter((evaluation) => evaluation.courant)[0]
    const sousEvaluations = evaluation?.sousEvaluations
    const filteredSousEvaluations = sousEvaluations?.filter(sousEval => beneficiairesVictimes?.includes(sousEval?.victime?.codeId));


    console.log(beneficiairesVictimes)
    console.log(sousEvaluationsSelected)
    console.log(completeSousEvSelected)
    const totalMontant = sousEvaluations?.prejudices?.reduce(
        (acc, curr) => acc + (curr.montant || 0), 0
    );

    const [isPartielOrTotal, setIsPartielOrTotal] = useState(false)

    useEffect(() => {
        const fetchMotifs = async () => {
            setMotifsLoading(true)
            const response = await getParametre(PARAMETERS.motifReglement)
            console.log("motifs: ", response.data)
            setMotifs(response.data)
            setMotifsLoading(false)
        }
        fetchMotifs()
    }, []);

    useEffect(() => {
        if (motifs) {
            setOptions(motifs.map((motif) => ({
                label: motif.valeur, // Display value
                value: motif.valeur, // Selected value
            })));
        }
    }, [motifs]);

    // Called when a motif is selected
    const onMotifSelect = (value) => {
        handleFindMotif(value); // This should eventually call setTextValue with content
        const selectedOption = options.find(opt => opt.value === value);
        setTextValue(selectedOption?.label || '');
    };


    const handleFindMotif = (e) => {
        setMotifReglement(e)
    }

    const addItem = (e) => {
        e.preventDefault();

        if (!name?.trim()) {
            return; // Prevent adding empty or whitespace-only items
        }

        setOptions((prevOptions) => [...prevOptions, { label: name, value: name }]); // Update options immutably

        setName(""); // Clear the input field

        inputRef.current?.focus(); // Focus the input directly
    };

    return (<>
        <Modal
            title={'Règlement Recours Sinistre'}
            open={modalControl.open}
            confirmLoading={decaissementLoading}
            style={{
                width: '500px'
            }}
            onCancel={() => {
                modalControl.setOpen(false)
                setIsVictimeBeneficiaire(null)
                setBeneficiaire(null)
                setIsPartielOrTotal(null)
            }}
            okText="Valider"
            cancelText="Annuler"
            onOk={async () => {
                setDecaissementLoading(true);

                if (!beneficiaire) {
                    toast.error("Veuillez choisir un beneficiaire");
                    setDecaissementLoading(false);
                    return;
                }
                if (!motifReglement) {
                    toast.error("Veuillez choisir un motif de reglement");
                    setDecaissementLoading(false);
                    return;
                }

                if (!montantReglement) {
                    toast.error("Veuillez renseigner le montant du reglement");
                    setDecaissementLoading(false);
                    return;
                }

                let result = {
                    beneficiaire: beneficiaire.personne ? beneficiaire?.personne : beneficiaire,
                    montantGlobal: parseFloat(montantReglement),
                    sinistre: sinistre,
                    motifReglement: textValue,
                    formuleDeFin: motifReglement,
                    expertise: false,
                    encaissement: true,
                    nature: "RECOURS",
                };

                console.log("Decaissement Result:", result);

                try {
                    await saveDecaissement(result);
                    console.log("Decaissement Result:", result);
                    toast.success('Decaissement effectué !');
                    setDecaissementLoading(false);
                    modalControl.setOpen(false);
                } catch (e) {
                    setDecaissementLoading(false);
                    toast.error(`Une erreur s'est produite !`);
                    console.error("Error:", e, "Result:", result);
                }
            }

            }
        >

            <div className="col-12">
                <label
                    style={{
                        margin: "15px 0 5px 0",
                    }}
                >
                    Sélectionner le bénéficiaire *
                </label>
                <Select
                    name="beneficiaire"
                    value={beneficiairesVictimes}
                    placeholder="Sélectionner les victimes"
                    style={{ width: "100%" }}
                    onChange={handleExpertChange}
                    options={[
                        {
                            label: <span>Victime(s)</span>,
                            title: 'Victime(s)',
                            options: victimes?.map((victime) => ({
                                label: `${victime.personne?.nom} ${victime.personne?.prenom}`,
                                value: victime.codeId
                            }))
                        },
                        {
                            label: <span>Expert(s)</span>,
                            title: 'Expert(s)',
                            options: experts?.map((expert) => ({
                                label: `${expert?.nom} ${expert?.prenom}`,
                                value: expert.codeId
                            }))
                        },
                    ]}
                />
            </div>
            <div className="col-12">
                <label
                    style={{
                        margin: "15px 0 5px 0",
                    }}
                >
                    Motif de règlement *
                </label>
                <Spin spinning={motifsLoading}>
                    <Select
                        id="motifRevision"
                        name="motifRevision"
                        placeholder="Motif de l'encaissement"
                        style={{ width: '100%', height: '50px' }}
                        dropdownRender={menu => (
                            <>
                                {menu}
                                <Divider style={{ margin: '8px 0' }} />
                                <Space style={{ padding: '0 8px 4px' }}>
                                    <Input
                                        placeholder="Ajouter un motif"
                                        ref={inputRef}
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                    />
                                    <Button
                                        type="text"
                                        icon={<PlusOutlined />}
                                        onClick={addItem}
                                    >
                                        Ajouter un motif
                                    </Button>
                                </Space>
                            </>
                        )}
                        options={options}
                        onChange={onMotifSelect}
                        value={motifReglement}
                    />
                    <TextArea
                        rows={5}
                        value={textValue}
                        onChange={(e) => setTextValue(e.target.value)}
                        placeholder="Modifier le motif ici..."
                        style={{ marginTop: 10 }}
                    />
                </Spin>
            </div>
            <div className="col-12">
                <label
                    style={{
                        margin: "15px 0 5px 0",
                    }}
                >
                    Montant de l'encaissement
                </label>

                <AmountInputNumber
                    name="montantReglement"
                    value={montantReglement || 0}
                    placeholder="Saisir le montant de l'encaissement"
                    style={{ width: '100%' }}
                    onChange={(value) => {
                        if (value === null || value === undefined || value === "") {
                            setMontantReglement(0);
                            return;
                        }
                        const nextValue = Number(value);
                        setMontantReglement(Number.isNaN(nextValue) ? 0 : nextValue);
                    }}
                />
            </div>
        </Modal>
    </>);
};

export default ReglementRecoursModal;
